/*
 * @Author: Gao Deng gaodeng@nextmar.com
 * @Date: 2023-10-30 13:36:21
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { request } from '../request';

const detail = {
  productDetail: (id, data) => request(`/api/products/show/${id}`, 'get', data),
  // 新版评论接口（分页）
  productReviewNew: (data) => request('/api/products/reviews_new', 'get', data),
  // 新版优质评论
  productReviewHigh: (data) => request('/api/products/reviews_head', 'get', data),
  // 添加helpful 评论点赞
  addHelpFulApi: (data) => request('/api/customer/add_helpful', 'post', data),
  // 移出helpful 取消评论点赞
  removeHelpFulApi: (data) => request('/api/customer/remove_helpful', 'post', data),
  notify: (data) =>
    request(`/api/products/notify/${data.id}`, 'post', data, {
      successMsg: true,
      errorMsg: true,
      msgType: 'box',
    }),
  lens: (data) => request('/api/lens/lens_show', 'get', data),
  coatings: (data) => request('/api/lens/coatings_show', 'get'),
  uploadPrescription: (data) => request('/api/customer/prescription/help_zendesk', 'post', data),
  recommend: (data) => request('/api/products/recommend', 'get', data, { errorMsg: false }),
  recommendById: (data) => request('/api/products/recommend_id', 'get', data, { errorMsg: false }),
  prescriptionRecognition: (data) =>
    request('/api/lens/prescription_recognition', 'get', data, { errorMsg: false }),
  lastProcessLens: (data) => request('/api/lens/get_last_lens', 'get', data, { errorMsg: false }),
  prescriptionShow: (data) =>
    request('/api/lens/prescription_show', 'get', data, { errorMsg: false }),
};

export default detail;
